export default function Icon({
  name,
  style,
  className,
  path = "ui", // menu, payments, sports
}) {
  if (!name) return null;

  const iconPath = path ? `${path}/${name}` : name;

  return (
    <svg className={className} style={style} data-path={path} data-name={name}>
      <use href={`/icons/${iconPath}.svg?#${name}`}></use>
    </svg>
  );
}
